/*
 * @Author: 赵泽文
 * @Date: 2023-02-06 20:47:02
 * @LastEditors: 赵泽文
 * @LastEditTime: 2023-06-13 09:08:35
 * @Description: file content
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { zh } from './zh';
import { en } from './en';
import { localCache } from '@/utils/storageHandler';

export const resources = {
  zh: {
    translation: { ...zh },
  },
  en: {
    translation: { ...en },
  },
};

i18n.use(initReactI18next).init({
  resources,
  // 默认显示中文
  lng: localCache?.getItem('MarsLanguage') || 'zh',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;

/** 默认以中文包的key值作为类型 */
export type TTranslationKey = keyof typeof zh;

/**
 * 国际化翻译调用方法
 * @params key 语言包关键词(默认以中文包的key值作为类型)
 * @params interpolation 插值变量
 */
export type TTranslation = (key: TTranslationKey, interpolation?: object) => string;

const t: TTranslation = (key: TTranslationKey, interpolation?: object) => {
  if (interpolation) {
    return i18n.t(key, interpolation);
  }
  return i18n.t(key);
};

window.t = t;
